module.exports = __webpack_public_path__ + "static/media/all_categories5.36fd7a26.png";